module.exports = __webpack_public_path__ + "img/d-1.7b0a8562.jpg";